/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsGetById } from "../funcs/deploymentsGetById.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetDeploymentResult } from "../models/components/getdeploymentresult.js";
import {
  GetDeploymentRequest,
  GetDeploymentSecurity,
} from "../models/operations/getdeployment.js";
import { unwrapAsync } from "../types/fp.js";
export type DeploymentQueryData = GetDeploymentResult;

export function prefetchDeployment(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetDeploymentRequest,
  security?: GetDeploymentSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeploymentQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeploymentQuery(
  client$: GramCore,
  request: GetDeploymentRequest,
  security?: GetDeploymentSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<DeploymentQueryData>;
} {
  return {
    queryKey: queryKeyDeployment({
      id: request.id,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function deploymentQueryFn(
      ctx,
    ): Promise<DeploymentQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deploymentsGetById(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeployment(
  parameters: {
    id: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deployments", "getById", parameters];
}
